import { useEffect } from 'react';
import { useRouter } from 'next/router';
import { overlay } from 'overlay-kit';
export const GlobalDialogManager = () => {
  const router = useRouter();
  const closeAll = () => {
    overlay.unmountAll();
  };
  useEffect(() => {
    router.events.on('routeChangeStart', closeAll);
    return () => {
      router.events.off('routeChangeStart', closeAll);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  return null;
};